export const AppContainerStyle = `
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #607d84;
`;
